import type { SnackbarConfig } from '@bos/snackbar';
import type { NavigateOptions } from '@tanstack/react-router';

import { router } from '../../router/router';

export const snackbarConfig: SnackbarConfig<NavigateOptions> = {
	navigate: (options) => {
		router.navigate(options);
	},
};
